export const platform = /(iPhone|iPod|BlackBerry|Android|Opera Mini|IEMobile|Windows Phone|webOS)/.test(
  navigator.userAgent
)
  ? 'mobile'
  : 'web';

export const isMobile = (): boolean => platform === 'mobile';
